import React, { useState } from "react";
import {
  fetchHydra as baseFetchHydra,
  HydraAdmin,
  FieldGuesser,
  ListGuesser,
  ResourceGuesser,
  CreateGuesser,
  EditGuesser,
  InputGuesser,
  useIntrospection,
  hydraDataProvider as baseHydraDataProvider,
} from "@api-platform/admin";
import { parseHydraDocumentation } from "@api-platform/api-doc-parser";
import {
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import { Navigate } from "react-router-dom";
import authProvider from "../authProvider";

let permissions = await authProvider.getPermissions();

const Admin = () => {
  const [redirectToLogin, setRedirectToLogin] = useState(false);

  const entrypoint = process.env.REACT_APP_API_URL as string;

  const getHeaders = () =>
    localStorage.getItem("token")
      ? { Authorization: `Bearer ${localStorage.getItem("token")}` }
      : {};

  const fetchHydra = (url: any, options: any = {}) =>
    baseFetchHydra(url, {
      ...options,
      headers: getHeaders,
    });

  const apiDocumentationParser = (setRedirectToLogin: (v: boolean) => void) => async () => {
    try {
      setRedirectToLogin(false);
      return await parseHydraDocumentation(entrypoint, { headers: getHeaders });
    } catch (result: any) {
      const { api, response, status } = result;
      if (status !== 401 || !response) {
        throw result;
      }

      localStorage.removeItem("token");
      setRedirectToLogin(true);

      return { api, response, status };
    }
  };

  const dataProvider = (setRedirectToLogin: (v: boolean) => void) =>
    baseHydraDataProvider({
      entrypoint,
      httpClient: fetchHydra,
      apiDocumentationParser: apiDocumentationParser(setRedirectToLogin),
    });

  const RedirectToLogin = () => {
    const introspect = useIntrospection();

    if (localStorage.getItem("token")) {
      introspect();
      return <></>;
    }
    return <Navigate to="/login" />;
  };

  const UserList = (props: any) =>
    permissions === "admin" && (
      <ListGuesser {...props}>
        <FieldGuesser source="email" />
      </ListGuesser>
    );

  const UserEdit = () => (
    <EditGuesser>
      <InputGuesser source="firstName" />
      <InputGuesser source="lastName" />
      <InputGuesser source="email" />
      <TextInput source="plainPassword" type="password" autoComplete="new-password" />
      <ReferenceInput label="Tenant" source="tenant" reference="tenants">
        <SelectInput optionText="name" />
      </ReferenceInput>
    </EditGuesser>
  );

  const UserCreate = () => (
    <CreateGuesser>
      <InputGuesser source="firstName" />
      <InputGuesser source="lastName" />
      <InputGuesser source="email" />
      <TextInput source="plainPassword" type="password" autoComplete="new-password" />
      <ReferenceInput label="Tenant" source="tenant" reference="tenants">
        <SelectInput optionText="name" />
      </ReferenceInput>
    </CreateGuesser>
  );

  const VesselList = (props: any) => (
    <ListGuesser {...props}>
      <FieldGuesser source="name" />
    </ListGuesser>
  );

  return (
    <HydraAdmin
      dataProvider={dataProvider(setRedirectToLogin)}
      authProvider={authProvider}
      entrypoint={entrypoint}
      basename="/admin"
    >
      {redirectToLogin || permissions !== "admin" ? (
        <>
          <ResourceGuesser name="users" list={UserList} />
          <RedirectToLogin />
        </>
      ) : (
        <>
          <ResourceGuesser name="tenants" />
          <ResourceGuesser name="users" edit={UserEdit} create={UserCreate} />
          <ResourceGuesser name="vessels" list={VesselList} />
        </>
      )}
    </HydraAdmin>
  );
};

export default Admin;